import client from '../client';

export const _getUserAssignmentsByRole = async (roleId) => {
  return await client.post(`users/assignmentsbyrole`, { role_id: roleId }, { credentials: 'omit' });
};

export const _getUserByRole = async (roleId) => {
  return await client.post(`users/usersbyrole`, { role_id: roleId }, { credentials: 'omit' });
};
